
import { useNavigate } from "react-router-dom";
import { openPopUp } from "../components/popUp";
import Table from "../components/table";
import { TableElementProps } from "../components/tableElement";
import { useSafeNavigate } from "../components/unloadBlocker";
import { PurchaseResponseDTO } from "../openapi-generated-client";
import { formatDate } from "../utils/dateUtils";
import PurchaseInfoPopUp from "./popup/purchaseInfoAdminPopUp";
import "./purchaseInfoTable.css";


interface PurchaseInfoTableProps {
    purchases: PurchaseResponseDTO[];
    refetch?: () => void;
}

export default function PurchaseInfoTable(props: PurchaseInfoTableProps) {

    const navigate = useSafeNavigate(useNavigate());
    
    var purchases = [...props.purchases];
    purchases.reverse();

    return <Table
        className="purchase-info-table"
        titles={["Date", "Buyer", "Seller", "Piece", "Price"]}
        elementSwitch={[0, 1, 3, 2]}
        elements={[...purchases.flatMap((e, i) => {
            var date = new Date(e.date);
            return [
                {
                    className: "date",
                    value: <>
                        <span className="no-style">{formatDate(date)}</span>
                    </>
                },
                {
                    className: e.accountId > 0 ? "hover" : "",
                    blue: true,
                    onClick: () => {
                        navigate("/artists/" + e.accountId);
                    },
                    value: e.accountName
                },
                {
                    className: e.composerId > 0 ? "hover" : "",
                    blue: true,
                    onClick: () => {
                        navigate("/artists/" + e.composerId);
                    },
                    value: e.composerName
                },
                {
                    className: e.pieceId > 0 ? "hover" : "",
                    blue: true,
                    onClick: () => {
                        navigate("/pieces/" + e.pieceId);
                    },
                    value: e.pieceName
                },
                {
                    className:"hover",
                    onClick: () => {
                        openPopUp(<PurchaseInfoPopUp data={e} />);
                    },
                    blue: true,
                    value: e.price
                }
            ];
        }) as TableElementProps[]]}
    />;
}